/*
 * Opticles custom wishlist.
 * Persists product handles in localStorage and refreshes product data from
 * Shopify when the dedicated wishlist page is opened.
 */
(function () {
  "use strict";

  // Procentul reducerii de bun venit vine din setarile temei (welcome-discount.liquid).
  function welcomeDiscountPercent() {
    var cfg = window.CiteraWelcomeDiscount || {};
    var pct = Number(cfg.percent);
    return pct > 0 && pct < 100 ? pct : 5;
  }

  if (window.OpticlesWishlist) return;

  var STORAGE_KEY = "opticles:wishlist:v1";
  var MAX_ITEMS = 100;
  var rootUrl =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  function normalize(items) {
    if (!Array.isArray(items)) return [];
    return items
      .filter(function (handle, index, all) {
        return (
          typeof handle === "string" &&
          /^[a-z0-9][a-z0-9-]*$/i.test(handle) &&
          all.indexOf(handle) === index
        );
      })
      .slice(0, MAX_ITEMS);
  }

  function read() {
    try {
      return normalize(JSON.parse(window.localStorage.getItem(STORAGE_KEY)));
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    var next = normalize(items);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      // The controls remain usable for this page view even when storage is disabled.
    }
    sync(document);
    document.dispatchEvent(
      new CustomEvent("opticles:wishlist:change", { detail: { items: next } })
    );
    return next;
  }

  function contains(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var items = read();
    var index = items.indexOf(handle);
    if (index === -1) {
      items.unshift(handle);
    } else {
      items.splice(index, 1);
    }
    return write(items);
  }

  function sync(scope) {
    var items = read();
    var count = items.length;
    (scope || document).querySelectorAll("[data-wishlist-toggle]").forEach(function (button) {
      var handle = button.getAttribute("data-product-handle");
      var active = items.indexOf(handle) !== -1;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");

      var label = button.querySelector("[data-wishlist-label]");
      if (label) label.textContent = active ? "Salvat în favorite" : "Adaugă la favorite";

      var productName = button.getAttribute("data-product-title");
      button.setAttribute(
        "aria-label",
        (active ? "Elimină" : "Adaugă") +
          (productName ? " " + productName : " produsul") +
          (active ? " din favorite" : " la favorite")
      );
    });

    document.querySelectorAll("[data-wishlist-count]").forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });

    document.querySelectorAll("[data-wishlist-link]").forEach(function (link) {
      link.setAttribute(
        "aria-label",
        count === 1 ? "Favorite, un produs salvat" : "Favorite, " + count + " produse salvate"
      );
    });
  }

  function escapeHtml(value) {
    var node = document.createElement("div");
    node.textContent = value == null ? "" : String(value);
    return node.innerHTML;
  }

  function imageUrl(url) {
    if (!url) return "";
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("width", "900");
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function formatMoney(cents, currency) {
    var value = Number(cents || 0) / 100;
    if (currency === "RON") {
      return (
        new Intl.NumberFormat("ro-RO", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value) + " lei"
      );
    }
    try {
      return new Intl.NumberFormat("ro-RO", {
        style: "currency",
        currency: currency || "RON",
      }).format(value);
    } catch (error) {
      return value.toFixed(2) + " " + (currency || "RON");
    }
  }

  function safeJson(value) {
    return JSON.stringify(value).replace(/</g, "\\u003c");
  }

  function productCard(product, currency) {
    var url = product.url || rootUrl + "products/" + product.handle;
    var image = imageUrl(product.featured_image || (product.images && product.images[0]));
    var compareAt = Number(product.compare_at_price || 0);
    var price = Number(product.price || 0);
    var onSale = compareAt > price;
    var priceHtml = onSale
      ? '<span class="wishlist-card__price-sale">' +
        escapeHtml(formatMoney(price, currency)) +
        '</span><s class="wishlist-card__price-compare">' +
        escapeHtml(formatMoney(compareAt, currency)) +
        "</s>"
      : escapeHtml(formatMoney(price, currency));
    var imageHtml = image
      ? '<img src="' +
        escapeHtml(image) +
        '" alt="' +
        escapeHtml(product.title) +
        '" width="900" height="900" loading="lazy">'
      : "";
    var availableVariant = (product.variants || []).find(function (variant) {
      return variant.available;
    });
    var compareVariant = availableVariant || (product.variants || [])[0] || {};
    var comparePrice = Number(compareVariant.price || product.price || 0);
    var comparePreviousPrice = Number(
      compareVariant.compare_at_price || product.compare_at_price || 0
    );
    var compareSaving =
      comparePreviousPrice > comparePrice ? comparePreviousPrice - comparePrice : 0;
    var compareDiscount =
      comparePreviousPrice > comparePrice
        ? Math.round((compareSaving * 100) / comparePreviousPrice)
        : 0;
    var compareProduct = {
      id: product.id,
      title: product.title || "",
      vendor: product.vendor || "",
      url: url,
      image: image,
      price: formatMoney(comparePrice, currency),
      previousPrice:
        comparePreviousPrice > comparePrice
          ? formatMoney(comparePreviousPrice, currency)
          : "",
      cardPrice: formatMoney(
        Math.round((comparePrice * (100 - welcomeDiscountPercent())) / 100),
        currency,
      ),
      saving: compareSaving ? formatMoney(compareSaving, currency) : "",
      discount: compareDiscount ? compareDiscount + "%" : "",
      sku: compareVariant.sku || "",
      category: product.type || "",
      audience: "",
      frameSize: "",
      lensWidth: "",
      bridgeWidth: "",
      templeLength: "",
      frameShape: "",
      frameType: "",
      frameMaterial: "",
      frameColor: "",
    };
    var actionHtml;

    if (!product.available || !availableVariant) {
      actionHtml =
        '<button type="button" class="button button--secondary wishlist-card__action wishlist-card__soldout" disabled>Stoc epuizat</button>';
    } else if ((product.variants || []).length === 1) {
      actionHtml =
        '<form action="' +
        escapeHtml(rootUrl + "cart/add") +
        '" method="post" data-cart-form>' +
        '<input type="hidden" name="id" value="' +
        escapeHtml(availableVariant.id) +
        '"><input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="button button--secondary wishlist-card__action">Adaugă în coș</button></form>';
    } else {
      actionHtml =
        '<a href="' +
        escapeHtml(url) +
        '" class="button button--secondary wishlist-card__action">Alege varianta</a>';
    }

    return (
      '<li><article class="wishlist-card" data-compare-product>' +
      '<button type="button" class="wishlist-toggle wishlist-card__remove is-active" ' +
      'data-wishlist-toggle data-product-handle="' +
      escapeHtml(product.handle) +
      '" data-product-title="' +
      escapeHtml(product.title) +
      '" aria-label="Elimină ' +
      escapeHtml(product.title) +
      ' din favorite" aria-pressed="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg></button>' +
      '<a class="wishlist-card__media" href="' +
      escapeHtml(url) +
      '">' +
      imageHtml +
      '</a><div class="wishlist-card__info">' +
      '<p class="wishlist-card__vendor">' +
      escapeHtml(product.vendor || "") +
      '</p><h2 class="wishlist-card__title"><a href="' +
      escapeHtml(url) +
      '">' +
      escapeHtml(product.title) +
      '</a></h2><div class="wishlist-card__price">' +
      priceHtml +
      '</div><div class="wishlist-card__actions">' +
      actionHtml +
      '<button class="sale-compare-toggle" type="button" data-sale-compare-toggle ' +
      'aria-pressed="false" aria-label="Adaugă ' +
      escapeHtml(product.title) +
      ' la comparație"><span aria-hidden="true">+</span><span>Compară</span></button>' +
      '</div></div><script type="application/json" data-compare-product-json>' +
      safeJson(compareProduct) +
      "</script></article></li>"
    );
  }

  function renderPage() {
    var page = document.querySelector("[data-wishlist-page]");
    if (!page) return;

    var grid = page.querySelector("[data-wishlist-grid]");
    var empty = page.querySelector("[data-wishlist-empty]");
    var status = page.querySelector("[data-wishlist-status]");
    var pageCount = page.querySelector("[data-wishlist-page-count]");
    var handles = read();
    var currency = page.getAttribute("data-currency") || "RON";
    var renderId = String(Date.now()) + Math.random();
    page.setAttribute("data-render-id", renderId);

    if (pageCount) {
      pageCount.textContent =
        handles.length === 1 ? "1 produs salvat" : handles.length + " produse salvate";
    }

    if (!handles.length) {
      grid.innerHTML = "";
      grid.hidden = true;
      empty.hidden = false;
      status.textContent = "";
      return;
    }

    empty.hidden = true;
    grid.hidden = true;
    status.textContent = "Încărcăm produsele salvate…";

    Promise.all(
      handles.map(function (handle) {
        return fetch(rootUrl + "products/" + encodeURIComponent(handle) + ".js", {
          headers: { Accept: "application/json" },
        })
          .then(function (response) {
            if (!response.ok) return null;
            return response.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      if (page.getAttribute("data-render-id") !== renderId) return;
      var validProducts = products.filter(Boolean);
      var validHandles = validProducts.map(function (product) {
        return product.handle;
      });

      if (validHandles.length !== handles.length) {
        try {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(validHandles));
        } catch (error) {
          // Ignore storage errors; the rendered list is still correct.
        }
        sync(document);
      }

      if (!validProducts.length) {
        grid.innerHTML = "";
        grid.hidden = true;
        empty.hidden = false;
        status.textContent = "";
        if (pageCount) pageCount.textContent = "0 produse salvate";
        return;
      }

      grid.innerHTML = validProducts
        .map(function (product) {
          return productCard(product, currency);
        })
        .join("");
      grid.hidden = false;
      status.textContent = "";
      if (pageCount) {
        pageCount.textContent =
          validProducts.length === 1
            ? "1 produs salvat"
            : validProducts.length + " produse salvate";
      }
      sync(grid);
    });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-wishlist-toggle]");
    if (!button) return;
    event.preventDefault();
    var handle = button.getAttribute("data-product-handle");
    if (!handle) return;
    toggle(handle);
  });

  document.addEventListener("opticles:wishlist:change", renderPage);
  document.addEventListener("shopify:section:load", function (event) {
    sync(event.target);
    renderPage();
  });
  window.addEventListener("storage", function (event) {
    if (event.key !== STORAGE_KEY) return;
    sync(document);
    renderPage();
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches("[data-wishlist-toggle]") || node.querySelector("[data-wishlist-toggle]")) {
          sync(node.matches("[data-wishlist-toggle]") ? node.parentElement || node : node);
        }
      });
    });
  });

  sync(document);
  renderPage();
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });

  window.OpticlesWishlist = {
    read: read,
    write: write,
    contains: contains,
    toggle: toggle,
    refresh: function () {
      sync(document);
      renderPage();
    },
  };
})();
